
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Anesthesia',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Anesthesia.vue